<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Service Reports</h1>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column">
          <input-select label="Analysis" v-model="analysis" required>
            <option value="equipment">Model Number</option>
            <option value="customer">Customer Name</option>
            <option value="serial">Serial Number</option>
          </input-select>
        </div>
        <div class="column" v-show="analysis">
          <input-field
            :label="identifierLabel"
            v-model="identifier"
            required
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="From"
            type="date"
            v-model="from"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="From"
            type="date"
            v-model="to"
            required
          ></input-field>
        </div>
      </div>
      <div class="is-flex">
        <button class="button is-borderless" @click="onCancelClicked">
          Cancel
        </button>
        <div class="is-expanded"></div>
        <button class="button is-primary" @click="onContinueClicked">
          Continue
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      analysis: "",
      identifier: "",
      from: "",
      to: ""
    };
  },
  methods: {
    onCancelClicked() {
      let component = this;
      component.$router.go(-1);
    },
    onContinueClicked() {
      let component = this;
      component.$router.push({
        path: `/report/service/view`,
        query: {
          analysis: component.analysis,
          identifier: component.identifier,
          from: component.from,
          to: component.to
        }
      });
    }
  },
  computed: {
    identifierLabel() {
      switch (this.analysis) {
        case "equipment":
          return "Model Number";
        case "customer":
          return "Customer Name";
        case "serial":
          return "Serial Number";
      }
    }
  },
  mounted() {
    this.$store.commit("setNavVisible", true);
  }
};
</script>
